import Vue from 'vue';
import ActionModal from '../components/ActionModal';
import buildFormParams from '../mixins/formParamBuilder';
import redtail from '../mixins/redtail';
import axios from 'axios';
import SelectAndImportGroupsFromRedtail from '../components/SelectAndImportGroupsFromRedtail';
import {getActiveCrmGroups} from '../utility/crms/getActiveCrmGroups';

Vue.component('onboarding-link-redtail-account', {
  data() {
    return {
      processing: true,
      userKey: null,
      error: null,
      validator: null,
      formParams: {userKey: '', username: ''},
      groups: [],
      selectedGroups: [],
      contactsCount: 0,
    };
  },
  computed: {
    userKeyMasked() {
      return 'XXXXXXXX-XXXX-XXXX-XXXX-XXXXX' + this.userKey.substr(this.userKey.length - 6);
    },
  },
  methods: {
    onVueAppErrors(errors) {
      this.$emit('vue-app-errors', errors);
    },
  },
  mixins: [buildFormParams, redtail],
  mounted() {
    setTimeout(() => {
      axios.get('/api/?entity=vessel&action=getRedtailIntegration').then(response => {
        let redtail = response.data;

        if (response !== false) {
          this.userKey = redtail.user_key;
          let self = this,
            redtailGroups = getActiveCrmGroups('redtail');

          redtailGroups.then(groups => {
            if (groups.length > 0) {
              self.groups = groups;
            }
          });
        }
        this.processing = false;
      });
    }, 2000);
  },
  props: {
    vesselId: {
      required: true,
    },
  },
  components: {ActionModal, SelectAndImportGroupsFromRedtail},
});
